import {Component, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';

@Component({
  selector: 'app-modal-create-library',
  templateUrl: './modal-create-library.component.html',
  styles: [
  ]
})
export class ModalCreateLibraryComponent extends  ExcTranslation implements OnInit {

  libName = '';
  libComment = '';
  data: any;
  constructor(private modalService: ExgModalService) {
    super();
  }
  ngOnInit(): void {
    if (this.data.libDescription) {
      this.libName = this.data.libDescription;
      this.libComment = this.data.libComment;
    }
  }
  closeModal(): void {
    const _self = this;
    _self.modalService.close();
}
  saveLibrary(): void {
    const _self = this;
    _self.modalService.action({libName: _self.libName, libComment: _self.libComment});
  }
  getHeader(): any {
    const _self = this;
    let header = '';
    if ( this.data.isLibrary){
      if (this.data.libDescription) {
        header = _self.getRessource('EditLibrary');
      }else {
        header = _self.getRessource('NewLibrary');
      }
    }else {
      if (this.data.libDescription) {
        header = _self.getRessource('EditDirectory');
      }else {
        header = _self.getRessource('NewDirectory');
      }
    }
    return header;
  }
}
